import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import type { PingRepository } from "@/entities/ping/domain/repository";
import type { GetPingsRequestDto, GetPingsResponseDto } from "@/entities/ping/domain/dtos";

@singleton()
export default class PingRepositoryImpl implements PingRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    /**
     * @description ping 조회
     * @param {GetPingsRequestDto} payload
     */
    public getPings = async (payload: GetPingsRequestDto): Promise<GetPingsResponseDto> => {
        const url = `/v1/pings?userId=${payload.userId}`;

        const response = await this.server.get<GetPingsResponseDto>(url);

        return response;
    };
}
